<template>
  <main id="app" class="container">
    <div class="row" @click="warning">
      <div class="left_colom col-lg-5">
        <div class="wrapper">
          <div class="pizza">
            <img class="testo" src="./img/Testo.png" alt />
            <img src="./img/bekon.png" v-show="bekon_img" />
            <img src="./img/ananas.png" alt v-show="ananas_img" />
            <img src="./img/brokoli.png" alt v-show="brokoli_img" />
            <img src="./img/cheese.png" alt v-show="cheese_img" />
            <img src="./img/Tomato.png" alt v-show="Tomato_img" />
            <img src="./img/krevetki.png" alt v-show="krevetki_img" />
            <img src="./img/midii.png" alt v-show="midii_img" />
            <img src="./img/ogurez.png" alt v-show="ogurez_img" />
            <img src="./img/riba.png" alt v-show="riba_img" />
            <img src="./img/sausage.png" alt v-show="sausage_img" />
            <img src="./img/shinka.png" alt v-show="shinka_img" />
            <img src="./img/telyatina.png" alt v-show="telyatina_img" />
            <img src="./img/olivki.png" alt v-show="olivki_img" />
            <img src="./img/perez.png" alt v-show="perez_img" />
            <img src="./img/kukuruza.png" alt v-show="kukuruza_img" />
          </div>
        </div>
        <div class="score">
          <h1>Стоимость пиццы: {{score}}</h1>
          <h5 v-show="!ingredient_warning">Не больше четырех ингредиентов!</h5>
        </div>
      </div>
      <div class="right_colom col-lg-7">
        <div class="ingredients">
          <button class="button9" @click="meat_switch">Мясное</button>
          <button class="button9" @click="veg_switch">Овощи</button>
          <button class="button9" @click="supplements_switch">Добавки</button>
        </div>

        <div class="ingredients_all">
          <div class="meat row" v-show="meat">
            <div class="block_ingredient">
              <img src="./img/bekon.png" alt width="170" />
              <h4>Бекон</h4>
              <h5>100 р.</h5>
              <button class="button27" @click="plus_bekon">+</button>
              {{count_bekon}}
              <button class="button27" @click="minus_bekon">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/telyatina.png" alt width="170" />
              <h4>Телятина</h4>
              <h5>90 р.</h5>
              <button class="button27" @click="plus_telyatina">+</button>
              {{count_telyatina}}
              <button class="button27" @click="minus_telyatina">-</button>
            </div>

            <div class="block_ingredient">
              <img src="./img/shinka.png" alt width="170" />
              <h4>Шинка</h4>
              <h5>150 р.</h5>
              <button class="button27" @click="plus_shinka">+</button>
              {{count_shinka}}
              <button class="button27" @click="minus_shinka">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/sausage.png" alt width="170" />
              <h4>Колбаса</h4>
              <h5>80 р.</h5>
              <button class="button27" @click="plus_sausage">+</button>
              {{count_sausage}}
              <button class="button27" @click="minus_sausage">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/riba.png" alt width="170" />
              <h4>Сёмга</h4>
              <h5>50 р.</h5>
              <button class="button27" @click="plus_riba">+</button>
              {{count_riba}}
              <button class="button27" @click="minus_riba">-</button>
            </div>
          </div>
          <div class="veg row" v-show="!veg">
            <div class="block_ingredient">
              <img src="./img/Tomato.png" alt width="170" />
              <h4>Помидоры</h4>
              <h5>20 р.</h5>
              <button class="button27" @click="plus_Tomato">+</button>
              {{count_Tomato}}
              <button class="button27" @click="minus_Tomato">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/brokoli.png" alt width="170" />
              <h4>Брокколи</h4>
              <h5>30 р.</h5>
              <button class="button27" @click="plus_brokoli">+</button>
              {{count_brokoli}}
              <button class="button27" @click="minus_brokoli">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/perez.png" alt width="170" />
              <h4>Перец</h4>
              <h5>10 р.</h5>
              <button class="button27" @click="plus_perez">+</button>
              {{count_perez}}
              <button class="button27" @click="minus_perez">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/ogurez.png" alt width="170" />
              <h4>Огурцы</h4>
              <h5>15 р.</h5>
              <button class="button27" @click="plus_ogurez">+</button>
              {{count_ogurez}}
              <button class="button27" @click="minus_ogurez">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/kukuruza.png" alt width="170" />
              <h4>Кукуруза</h4>
              <h5>10 р.</h5>
              <button class="button27" @click="plus_kukuruza">+</button>
              {{count_kukuruza}}
              <button class="button27" @click="minus_kukuruza">-</button>
            </div>
          </div>
          <div class="supplements row" v-show="!supplements">
            <div class="block_ingredient">
              <img src="./img/ananas.png" alt width="170" />
              <h4>Ананас</h4>
              <h5>50 р.</h5>
              <button class="button27" @click="plus_ananas">+</button>
              {{count_ananas}}
              <button class="button27" @click="minus_ananas">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/midii.png" alt width="170" />
              <h4>Мидии</h4>
              <h5>120 р.</h5>
              <button class="button27" @click="plus_midii">+</button>
              {{count_midii}}
              <button class="button27" @click="minus_midii">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/olivki.png" alt width="170" />
              <h4>Оливки</h4>
              <h5>20 р.</h5>
              <button class="button27" @click="plus_olivki">+</button>
              {{count_olivki}}
              <button class="button27" @click="minus_olivki">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/krevetki.png" alt width="170" />
              <h4>Криветки</h4>
              <h5>40 р.</h5>
              <button class="button27" @click="plus_krevetki">+</button>
              {{count_krevetki}}
              <button class="button27" @click="minus_krevetki">-</button>
            </div>
            <div class="block_ingredient">
              <img src="./img/cheese.png" alt width="170" />
              <h4>Сыр</h4>
              <h5>45 р.</h5>
              <button class="button27" @click="plus_cheese">+</button>
              {{count_cheese}}
              <button class="button27" @click="minus_cheese">-</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      score: 0,
      count: 0,
      meat: true,
      veg: true,
      supplements: true,
      count_bekon: 0,
      count_telyatina: 0,
      count_shinka: 0,
      count_sausage: 0,
      count_riba: 0,
      count_Tomato: 0,
      count_brokoli: 0,
      count_perez: 0,
      count_ogurez: 0,
      count_kukuruza: 0,
      count_ananas: 0,
      count_midii: 0,
      count_olivki: 0,
      count_krevetki: 0,
      count_cheese: 0,
      bekon_img: false,
      ananas_img: false,
      brokoli_img: false,
      cheese_img: false,
      Tomato_img: false,
      krevetki_img: false,
      midii_img: false,
      ogurez_img: false,
      riba_img: false,
      sausage_img: false,
      shinka_img: false,
      telyatina_img: false,
      olivki_img: false,
      perez_img: false,
      kukuruza_img: false,
      ingredient_warning: true,
      ingredient_bekon: 0,
      ingredient_telyatina: 0,
      ingredient_shinka: 0,
      ingredient_sausage: 0,
      ingredient_riba: 0,
      ingredient_Tomato: 0,
      ingredient_brokoli: 0,
      ingredient_perez: 0,
      ingredient_ogurez: 0,
      ingredient_kukuruza: 0,
      ingredient_ananas: 0,
      ingredient_cheese: 0,
      ingredient_midii: 0,
      ingredient_olivki: 0,
      ingredient_krevetki: 0
    };
  },
  methods: {
    warning: function() {
      if (
        this.ingredient_bekon +
          this.ingredient_telyatina +
          this.ingredient_shinka +
          this.ingredient_sausage +
          this.ingredient_riba +
          this.ingredient_Tomato +
          this.ingredient_brokoli +
          this.ingredient_perez +
          this.ingredient_ogurez +
          this.ingredient_kukuruza +
          this.ingredient_ananas +
          this.ingredient_cheese +
          this.ingredient_midii +
          this.ingredient_olivki +
          this.ingredient_krevetki >
        4
      )
        this.ingredient_warning = false;
      else this.ingredient_warning = true;
    },
    meat_switch: function() {
      this.meat = true;
      this.veg = true;
      this.supplements = true;
    },
    veg_switch: function() {
      this.meat = false;
      this.veg = false;
      this.supplements = true;
    },
    supplements_switch: function() {
      this.meat = false;
      this.veg = true;
      this.supplements = false;
    },
    plus_bekon: function() {
      if (this.ingredient_warning == true) {
        if (this.count_bekon < 3) {
          this.count_bekon++;
          this.bekon_img = true;
          this.score += 100;
        }
        if (this.count_bekon == 1) this.ingredient_bekon = 1;
      } else return 0;
    },
    minus_bekon: function() {
      if (this.count_bekon > 0) {
        this.count_bekon--;
        this.score -= 100;
      }
      if (this.count_bekon == 0) this.bekon_img = false;
      if (this.count_bekon == 0) this.ingredient_bekon = 0;
    },
    plus_telyatina: function() {
      if (this.ingredient_warning == true) {
        if (this.count_telyatina < 3) {
          this.count_telyatina++;
          this.telyatina_img = true;
          this.score += 90;
        }
        if (this.count_telyatina == 1) this.ingredient_telyatina = 1;
      } else return 0;
    },
    minus_telyatina: function() {
      if (this.count_telyatina > 0) {
        this.count_telyatina--;
        this.score -= 90;
      }
      if (this.count_telyatina == 0) this.telyatina_img = false;
      if (this.count_telyatina == 0) this.ingredient_telyatina = 0;
    },
    plus_shinka: function() {
      if (this.ingredient_warning == true) {
        if (this.count_shinka < 3) {
          this.count_shinka++;
          this.shinka_img = true;
          this.score += 150;
        }
        if (this.count_shinka == 1) this.ingredient_shinka = 1;
      } else return 0;
    },
    minus_shinka: function() {
      if (this.count_shinka > 0) {
        this.count_shinka--;
        this.score -= 150;
      }
      if (this.count_shinka == 0) this.shinka_img = false;
      if (this.count_shinka == 0) this.ingredient_shinka = 0;
    },
    plus_sausage: function() {
      if (this.ingredient_warning == true) {
        if (this.count_sausage < 3) {
          this.count_sausage++;
          this.sausage_img = true;
          this.score += 80;
        }
        if (this.count_sausage == 1) this.ingredient_sausage = 1;
      } else return 0;
    },
    minus_sausage: function() {
      if (this.count_sausage > 0) {
        this.count_sausage--;
        this.score -= 80;
      }
      if (this.count_sausage == 0) this.sausage_img = false;
      if (this.count_sausage == 0) this.ingredient_sausage = 0;
    },
    plus_riba: function() {
      if (this.ingredient_warning == true) {
        if (this.count_riba < 3) {
          this.count_riba++;
          this.riba_img = true;
          this.score += 50;
        }
        if (this.count_riba == 1) this.ingredient_riba = 1;
      } else return 0;
    },
    minus_riba: function() {
      if (this.count_riba > 0) {
        this.count_riba--;
        this.score -= 50;
      }
      if (this.count_riba == 0) this.riba_img = false;
      if (this.count_riba == 0) this.ingredient_riba = 0;
    },
    plus_Tomato: function() {
      if (this.ingredient_warning == true) {
        if (this.count_Tomato < 3) {
          this.count_Tomato++;
          this.Tomato_img = true;
          this.score += 20;
        }
        if (this.count_Tomato == 1) this.ingredient_Tomato = 1;
      } else return 0;
    },
    minus_Tomato: function() {
      if (this.count_Tomato > 0) {
        this.count_Tomato--;
        this.score -= 20;
      }
      if (this.count_Tomato == 0) this.Tomato_img = false;
      if (this.count_Tomato == 0) this.ingredient_Tomato = 0;
    },
    plus_brokoli: function() {
      if (this.ingredient_warning == true) {
        if (this.count_brokoli < 3) {
          this.count_brokoli++;
          this.brokoli_img = true;
          this.score += 30;
        }
        if (this.count_brokoli == 1) this.ingredient_brokoli = 1;
      } else return 0;
    },
    minus_brokoli: function() {
      if (this.count_brokoli > 0) {
        this.count_brokoli--;
        this.score -= 30;
      }
      if (this.count_brokoli == 0) this.brokoli_img = false;
      if (this.count_brokoli == 0) this.ingredient_brokoli = 0;
    },
    plus_perez: function() {
      if (this.ingredient_warning == true) {
        if (this.count_perez < 3) {
          this.count_perez++;
          this.perez_img = true;
          this.score += 10;
        }
        if (this.count_perez == 1) this.ingredient_perez = 1;
      } else return 0;
    },
    minus_perez: function() {
      if (this.count_perez > 0) {
        this.count_perez--;
        this.score -= 10;
      }
      if (this.count_perez == 0) this.perez_img = false;
      if (this.count_perez == 0) this.ingredient_perez = 0;
    },
    plus_ogurez: function() {
      if (this.ingredient_warning == true) {
        if (this.count_ogurez < 3) {
          this.count_ogurez++;
          this.ogurez_img = true;
          this.score += 15;
        }
        if (this.count_ogurez == 1) this.ingredient_ogurez = 1;
      } else return 0;
    },
    minus_ogurez: function() {
      if (this.count_ogurez > 0) {
        this.count_ogurez--;
        this.score -= 15;
      }
      if (this.count_ogurez == 0) this.ogurez_img = false;
      if (this.count_ogurez == 0) this.ingredient_ogurez = 0;
    },
    plus_kukuruza: function() {
      if (this.ingredient_warning == true) {
        if (this.count_kukuruza < 3) {
          this.count_kukuruza++;
          this.kukuruza_img = true;
          this.score += 10;
        }
        if (this.count_kukuruza == 1) this.ingredient_kukuruza = 1;
      } else return 0;
    },
    minus_kukuruza: function() {
      if (this.count_kukuruza > 0) {
        this.count_kukuruza--;
        this.score -= 10;
      }
      if (this.count_kukuruza == 0) this.kukuruza_img = false;
      if (this.count_kukuruza == 0) this.ingredient_kukuruza = 0;
    },
    plus_ananas: function() {
      if (this.ingredient_warning == true) {
        if (this.count_ananas < 3) {
          this.count_ananas++;
          this.ananas_img = true;
          this.score += 50;
        }
        if (this.count_ananas == 1) this.ingredient_ananas = 1;
      } else return 0;
    },
    minus_ananas: function() {
      if (this.count_ananas > 0) {
        this.count_ananas--;
        this.score -= 50;
      }
      if (this.count_ananas == 0) this.ananas_img = false;
      if (this.count_ananas == 0) this.ingredient_ananas = 0;
    },
    plus_midii: function() {
      if (this.ingredient_warning == true) {
        if (this.count_midii < 3) {
          this.count_midii++;
          this.midii_img = true;
          this.score += 120;
        }
        if (this.count_midii == 1) this.ingredient_midii = 1;
      } else return 0;
    },
    minus_midii: function() {
      if (this.count_midii > 0) {
        this.count_midii--;
        this.score -= 120;
      }
      if (this.count_midii == 0) this.midii_img = false;
      if (this.count_midii == 0) this.ingredient_midii = 0;
    },
    plus_olivki: function() {
      if (this.ingredient_warning == true) {
        if (this.count_olivki < 3) {
          this.count_olivki++;
          this.olivki_img = true;
          this.score += 20;
        }
        if (this.count_olivki == 1) this.ingredient_olivki = 1;
      } else return 0;
    },
    minus_olivki: function() {
      if (this.count_olivki > 0) {
        this.count_olivki--;
        this.score -= 20;
      }
      if (this.count_olivki == 0) this.olivki_img = false;
      if (this.count_olivki == 0) this.ingredient_olivki = 0;
    },
    plus_krevetki: function() {
      if (this.ingredient_warning == true) {
        if (this.count_krevetki < 3) {
          this.count_krevetki++;
          this.krevetki_img = true;
          this.score += 40;
        }
        if (this.count_krevetki == 1) this.ingredient_krevetki = 1;
      } else return 0;
    },
    minus_krevetki: function() {
      if (this.count_krevetki > 0) {
        this.count_krevetki--;
        this.score -= 40;
      }
      if (this.count_krevetki == 0) this.krevetki_img = false;
      if (this.count_krevetki == 0) this.ingredient_krevetki = 0;
    },
    plus_cheese: function() {
      if (this.ingredient_warning == true) {
        if (this.count_cheese < 3) {
          this.count_cheese++;
          this.cheese_img = true;
          this.score += 45;
        }
        if (this.count_cheese == 1) this.ingredient_cheese = 1;
      } else return 0;
    },
    minus_cheese: function() {
      if (this.count_cheese > 0) {
        this.count_cheese--;
        this.score -= 45;
      }
      if (this.count_cheesei == 0) this.cheesei_img = false;
      if (this.count_cheese == 0) this.ingredient_cheese = 0;
    }
  }
};
</script>

<style>
@import url(normilaze.css);
body {
  background: url(img/general-bg.jpg);
  background-size: cover;
  padding-top: 50px;
}

.wrapper {
  text-align: center;
  margin-bottom: 380px;
  max-width: 400px;
}

.pizza img {
  position: absolute;
  display: block;
}

.block_ingredient img {
  max-width: 300px;
}

.score {
  margin-left: 20%;
}

.ingredients {
  margin-top: 30px;
  margin-left: 20%;
}

.ingredients button {
  margin-left: 20px;
}

.left_colom {
  text-align: center;
}

.button9 {
  position: relative;
  display: inline-block;
  color: #777674;
  font-weight: bold;
  text-decoration: none;
  text-shadow: rgba(255, 255, 255, 0.5) 1px 1px,
    rgba(100, 100, 100, 0.3) 3px 7px 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 1em 2em;
  outline: none;
  border-radius: 3px / 100%;
  background-image: -o-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0.8),
      rgba(255, 255, 255, 0) 70%
    ),
    -o-linear-gradient(left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0) 20%, rgba(
            255,
            255,
            255,
            0
          )
          90%, rgba(255, 255, 255, 0.3)),
    -o-linear-gradient(left, rgba(125, 125, 125, 1), rgba(255, 255, 255, 0.9)
          45%, rgba(125, 125, 125, 0.5)),
    -o-linear-gradient(left, rgba(125, 125, 125, 1), rgba(255, 255, 255, 0.9)
          45%, rgba(125, 125, 125, 0.5)),
    -o-linear-gradient(left, rgba(223, 190, 170, 1), rgba(255, 255, 255, 0.9)
          45%, rgba(223, 190, 170, 0.5)),
    -o-linear-gradient(left, rgba(223, 190, 170, 1), rgba(255, 255, 255, 0.9)
          45%, rgba(223, 190, 170, 0.5));
  background-image: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0.8),
      rgba(255, 255, 255, 0) 70%
    ),
    linear-gradient(
      to right,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0) 20%,
      rgba(255, 255, 255, 0) 90%,
      rgba(255, 255, 255, 0.3)
    ),
    linear-gradient(
      to right,
      rgba(125, 125, 125, 1),
      rgba(255, 255, 255, 0.9) 45%,
      rgba(125, 125, 125, 0.5)
    ),
    linear-gradient(
      to right,
      rgba(125, 125, 125, 1),
      rgba(255, 255, 255, 0.9) 45%,
      rgba(125, 125, 125, 0.5)
    ),
    linear-gradient(
      to right,
      rgba(223, 190, 170, 1),
      rgba(255, 255, 255, 0.9) 45%,
      rgba(223, 190, 170, 0.5)
    ),
    linear-gradient(
      to right,
      rgba(223, 190, 170, 1),
      rgba(255, 255, 255, 0.9) 45%,
      rgba(223, 190, 170, 0.5)
    );
  background-repeat: no-repeat;
  background-size: 200% 100%, auto, 100% 2px, 100% 2px, 100% 1px, 100% 1px;
  background-position: 200% 0, 0 0, 0 0, 0 100%, 0 4px, 0 calc(100% - 4px);
  -webkit-box-shadow: rgba(0, 0, 0, 0.5) 3px 10px 10px -10px;
  box-shadow: rgba(0, 0, 0, 0.5) 3px 10px 10px -10px;
  max-width: 130px;
}

.button9:hover {
  -webkit-transition: 0.5s linear;
  -o-transition: 0.5s linear;
  transition: 0.5s linear;
  background-position: -200% 0, 0 0, 0 0, 0 100%, 0 4px, 0 calc(100% - 4px);
}

.button9:active {
  top: 1px;
}

.block_ingredient {
  text-align: center;
  margin-left: 30px;
  max-width: 200px;
}

.button27 {
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  color: #000;
  outline: none;
  border-radius: 40px;
  -webkit-box-shadow: 0 0 0 1px #ddd inset, 0 1px 1px #fff;
  box-shadow: 0 0 0 1px #ddd inset, 0 1px 1px #fff;
  text-align: center;
  padding-bottom: 35px;
}

.button27:hover {
  background: #dcdcdc -webkit-gradient(linear, left top, left bottom, from(#fff), to(#dcdcdc));
  background: #dcdcdc -o-linear-gradient(#fff, #dcdcdc);
  background: #dcdcdc linear-gradient(#fff, #dcdcdc);
  -webkit-box-shadow: 0 0 0 1px #aaa inset, 0 1px 1px #aaa;
  box-shadow: 0 0 0 1px #aaa inset, 0 1px 1px #aaa;
}

.button27:active {
  background: none;
  -webkit-box-shadow: 0 0 0 1px #bbb inset, 0 1px 3px rgba(0, 0, 0, 0.5) inset,
    0 1px 2px #fff;
  box-shadow: 0 0 0 1px #bbb inset, 0 1px 3px rgba(0, 0, 0, 0.5) inset,
    0 1px 2px #fff;
  text-decoration: none;
}

.score h5 {
  color: red;
}

@media (max-width: 1000px) {
  .wrapper {
    margin-left: 25%;
  }
}

@media (max-width: 450px) {
  .wrapper {
    margin-left: 0;
  }

  .meat {
    margin-left: 15%;
  }

  .ingredients {
    margin-left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .ingredients button {
    margin-left: 0;
  }
}
</style>
